import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CannotFindAnOrderIA = function CannotFindAnOrderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qs+yOq",
    defaultMessage: [{
      "type": 0,
      "value": "If you’re having trouble finding a retailer’s order in your Faire account, it might be due to a few different reasons. Here are some steps you can take to address this issue:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8Hf+hC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Order still processing:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+J5CGL",
    defaultMessage: [{
      "type": 0,
      "value": "Ask the retailer to provide any additional information they might have about their account and encourage them to contact us directly for further assistance."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Q7Q0DJ",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Different order numbers:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "s5nkQH",
    defaultMessage: [{
      "type": 0,
      "value": "If a retailer gives you an order number that doesn’t appear on your "
    }, {
      "children": [{
        "type": 0,
        "value": "Orders"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " page, ask them for their "
    }, {
      "children": [{
        "type": 0,
        "value": "invoice number"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " instead. The invoice number should match the order number you see, allowing you to locate the order."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks);
      },
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JDfmRL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "New accounts under review:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "PDY+PO",
    defaultMessage: [{
      "type": 0,
      "value": "If a retailer has provided their invoice number but you’re still unable to find their order, it’s possible that the retailer has a new account that’s on hold while our team reviews their information. This review process should take no more than a few days."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IkPzxw",
    defaultMessage: [{
      "type": 0,
      "value": "If you’ve checked the above and still can’t locate the order, contact us for further assistance. We’re here to help resolve these issues."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};